import { useContext, useEffect, useState } from "react";
import Modal from "../../utils/modal"
import LoadingOverlay from "../../atoms/loadingOverlay";
import Button from "../../atoms/button";
import HistoryCard from "./historyCard";
import ToastContext from "../../../context/toastProvider";
import { getOrderAdapter } from "../../orders/orderAdapters";

const gradingAdapter = getOrderAdapter("grading");

const ProductHistory = ({ user, product, close, refresh, adapter = gradingAdapter, stores }) => {

    const { goodToast, badToast } = useContext(ToastContext);

    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        doGetProductHistory();
        // eslint-disable-next-line 
    }, [])

    const doGetProductHistory = async () => {
        setLoading(true);
        const data = await adapter.history(user?.token, product?._id);
        if (data?.type === "success") {
            setHistory(data?.data?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()));
        }
        setLoading(false);
    }
    
    const restoreVersion = async (his) => {
        setLoading(true);
        const data = await adapter.restore(user?.token, product?._id, his);
        if(data?.type === "success"){
            goodToast("Versão restaurada!");
            close();
            refresh();
            setLoading(false);
            return null;
        }
        badToast(adapter.restoreErrorMessage(data));
        setLoading(false);
    }

    return (
        <Modal handleClose={close}>
            <div className="relative">
                <h2 className="text-center mb-4 text-lg font-bold">Histórico de versões do pedido</h2>
                {
                    !history?.length ?
                        <p className="text-center text-[#666]">Nenhum histórico encontrado</p>
                        :
                        history?.map((h, i) => (
                            <HistoryCard key={i} product={product} history={h} update={restoreVersion} showGradingType={adapter.capabilities.gradingType} stores={stores}/>
                        ))
                }
                <Button classes="bg-red-500 hover:bg-red-300 mt-4" click={close}>Fechar</Button>
                <LoadingOverlay loading={loading} />
                <div className="absolute top-0 right-0 text-primary text-xl font-bold cursor-pointer" onClick={close}>X</div>
            </div>
        </Modal>
    )
}

export default ProductHistory;
